var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data && _vm.data.length !== 0)?_c('div',{staticClass:"object_chart"},[_c('div',{staticClass:"object_chart__content"},[_c('h2',[_vm._v("График роста цен и спрос на объект")]),(_vm.data && _vm.data.length !== 0)?_c('ChartComponent',{staticClass:"object_chart__content-item",attrs:{"data":_vm.charts_item}}):_vm._e()],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }